import React from 'react';
import { Flex, Heading, Box } from '@spothero/ui';
import SpotDetailsMap from '../spot-details-map';
const GettingThere = ({ instructions, spotLongitude, spotLatitude, }) => {
    const formattedInstructions = instructions?.replace(/\r?\n/g, '<br>');
    return (
    // TODO When rest of components on this page are updated, remove classname here
    <Flex className="SpotDetails-section" direction="column" paddingY={6} data-testid="GettingThere">
            <Heading fontSize="base" marginBottom={4} as="h4">
                Getting There
            </Heading>

            <SpotDetailsMap spotLongitude={spotLongitude} spotLatitude={spotLatitude}/>
            {instructions ? (<Box marginTop={4} dangerouslySetInnerHTML={{
                __html: formattedInstructions,
            }}/>) : null}
        </Flex>);
};
export default GettingThere;
